import React from 'react'

const EmptyProposalCard = () => {
  return (
    <>
    <div className="d-flex align-items-center justify-content-between w-100 px-4">
                    <div className="gray-box-large">
                        
                    </div>
                    <div className="d-flex gap-4">
                        <div className="gray-box-large"></div>
                        <div className="gray-box-small">
                        </div>
                    </div>
                </div>
                <hr style={{margin: '12px 0'}} />
                </>
  )
}

export default EmptyProposalCard